<template>
  <van-nav-bar
    title="订单列表"
    left-text="返回"
    right-text="停餐记录"
    left-arrow
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
  <van-empty v-if="listSize == 0" description="暂无内容" />
  <div v-if="listSize > 0" style="margin-bottom: 40px">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="20"
      @load="onLoad"
    >
      <van-cell-group
        inset
        v-for="item in list"
        :key="item.payment_id"
        style="margin-top: 5px"
      >
        <van-config-provider :theme-vars="cellValueTextColor">
        <van-cell :title="item.success_time">
          <template #value>
            <span v-if="item.isshow === 1" class="custom-title" @click="applyFor(item.charge_restaurant_id)"
              >申请停餐 ></span
            >
          </template>
        </van-cell>
        </van-config-provider>
        <van-cell :title="item.catering_company" />
        <van-cell :title="item.cost_name" />
        <van-cell :title="'订单金额: ¥' + item.cost" />
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    // const Route = useRoute(); //获取到值
    const router = useRouter(); //路由传值
    const child_id = ref("");
    const child_name = ref("");
    const school_name = ref("");
    const class_name = ref("");
    const listSize = ref(1);

    const cellValueTextColor = {
      cellValueColor	: '#1989FA',
    };
    onMounted(() => {
      if (getQuery("child_id")) {
        localStorage.setItem("childId", getQuery("child_id"));
        localStorage.setItem("childName", getQuery("child_name"));
        localStorage.setItem("schoolName", getQuery("school_name"));
        localStorage.setItem("className", getQuery("class_name"));
      }
      child_id.value = localStorage.getItem("childId");
      child_name.value = localStorage.getItem("childName");
      school_name.value = localStorage.getItem("schoolName");
      class_name.value = localStorage.getItem("className");
    });

    // const toOrderList = () => {
    //   router.push({
    //     path: "/orderList",
    //   });
    // };
    const onLoad = () => {
      finished.value = false;
      loading.value = true;
      api
        .getRestaurantOrderList({
          child_id: child_id.value,
        })
        .then((res) => {
          if (res.data.code == 34508) {
            let result = res.data.result;
            let companyList = result;
            for (let i = 0; i < companyList.length; i++) {
              list.value.push(companyList[i]);
            }
            listSize.value = list.value.length;
            // 加载状态结束
            loading.value = false;

            // 数据全部加载完成
            finished.value = true;
          } else {
            listSize.value = 0;
            finished.value = true;
          }
        })
        .catch((err) => {
          finished.value = true;
          listSize.value = 0;
          Toast(err.message);
        });
    };

    /**
     * 申请停餐
     */
    const applyFor = (charge_restaurant_id) => {
      router.push({
        path: "/applyFor",
        query: {
          child_id: child_id.value,
          child_name: child_name.value,
          school_name: school_name.value,
          class_name: class_name.value,
          charge_restaurant_id: charge_restaurant_id,
        },
      });
    };

    function getQuery(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURI(pair[1]);
        }
      }
      return false;
    }

    const onClickLeft = () => {
      router.go(-1);
    };
    const onClickRight = () => {
      router.push({
        path: "/stopMealList",
        query: {
          // child_id: child_id.value,
          // child_name: child_name.value,
          // school_name: school_name.value,
          // class_name: class_name.value,
        },
      });
    };

    return {
      list,
      onLoad,
      loading,
      finished,
      child_id,
      child_name,
      school_name,
      class_name,
      listSize,
      applyFor,
      onClickLeft,
      onClickRight,
      cellValueTextColor,
    };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.container span:first-child {
  flex: 1;
  text-align: left;
}

.container span:last-child {
  flex: 0 0 auto;
  text-align: right;
}

.clickable {
  cursor: pointer; /* 可点击的鼠标指针 */
}

.clickable.disabled {
  cursor: not-allowed; /* 不可点击的鼠标指针 */
  opacity: 0.5; /* 降低透明度表示不可点击 */
  pointer-events: none; /* 阻止点击事件 */
}
</style>
